import { TypeLieu } from './TypeLieu';
import { TypeObjCPV } from './TypeObjCPV';
import { TypeFournitures } from './TypeFournitures';
import { TypeTravaux } from './TypeTravaux';

export class DescriptionReduite {

  public objet: string;

  constructor() {
    this.objet = '';
  }
}
